var Color = require('color');

export default {
  apply(color, moqoColor) {

    const darkenColor = Color(color).darken(0.2).hex()

    document.getElementById('injected-styles').innerHTML = `
      header.header--with-bg .hamburger-inner,
      header.header--with-bg .hamburger-inner:after,
      header.header--with-bg .hamburger-inner:before {
        background-color: ${color} !important;
        box-shadow: none;
      }

      header.colored, .colored {
        background-color: ${color};
      }

      .text-color {
        color: ${color};
      }

      .user-generated {
        overflow-wrap: break-word;
        word-wrap: break-word;
      }

      .user-generated a,
      .user-generated a:active,
      .user-generated a:visited {
        color: ${color};
        text-decoration: none;
        text-transform: none;
      }

      .user-generated a:hover {
        text-decoration: underline;
      }

      header.header--with-bg .menu li a,
      header.header--with-bg .site-name h3,
      header.header--with-bg .site-name p{
        color: ${color} !important;
      }

      body a.moqo_link--button.moqo_link--custom-color {
        -webkit-box-shadow: 0.25rem 0.25rem 0 0 ${darkenColor};
        box-shadow: 0.25rem 0.25rem 0 0 ${darkenColor};
      }
      body a.moqo_link--button.moqo_link--custom-color:hover {
        -webkit-box-shadow: 0.1875rem 0.1875rem 0 0 ${darkenColor};
        box-shadow: 0.1875rem 0.1875rem 0 0 ${darkenColor};
      }
      body a.moqo_link--button.moqo_link--custom-color:active {
        -webkit-box-shadow: none;
        box-shadow: none;
      }

      body a.moqo_link--button.moqo_link--large.moqo_link--custom-color {
        -webkit-box-shadow: 0.375rem 0.375rem 0 0 ${darkenColor};
        box-shadow: 0.375rem 0.375rem 0 0 ${darkenColor};
      }
      body a.moqo_link--button.moqo_link--large.moqo_link--custom-color:hover {
        -webkit-box-shadow: 0.25rem 0.25rem 0 0 ${darkenColor};
        box-shadow: 0.25rem 0.25rem 0 0 ${darkenColor};
      }
      body a.moqo_link--button.moqo_link--large.moqo_link--custom-color:active {
        -webkit-box-shadow: none;
        box-shadow: none;
      }

      a.moqo-link {
        color: ${moqoColor};
        font-weight: ${moqoColor === '#0a0a0a' ? 'bold' : 'normal'}
      }
    `

  }
}



// WEBPACK FOOTER //
// ./src/lib/injected_styles.js